import React from 'react'
import { Link } from 'react-router-dom'
import { Calendar, Clock, Eye } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card'
import { Badge } from './ui/badge'
import { formatDate, truncateText } from '../lib/utils'
import { Post } from '../types'

interface BlogPostProps {
  post: Post
  category?: {
    name: string
    slug: string
    color: string
  }
}

const BlogPost: React.FC<BlogPostProps> = ({ post, category }) => {
  const badgeVariant = category?.color as any || 'default'

  return (
    <Link to={`/${category?.slug || 'category'}/${post.slug}`}>
      <Card className="h-full hover:shadow-elevated transition-all duration-300 hover:scale-105 cursor-pointer group">
        {post.featured_image_url && (
          <div className="aspect-video overflow-hidden rounded-t-lg">
            <img 
              src={post.featured_image_url} 
              alt={post.title}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
            />
          </div>
        )}
        
        <CardHeader>
          <div className="flex items-center justify-between mb-2">
            {category && (
              <Badge variant={badgeVariant} className="text-xs">
                {category.name}
              </Badge>
            )}
            <div className="flex items-center text-sm text-gray-500">
              <Eye className="h-3 w-3 mr-1" />
              {post.view_count}
            </div>
          </div>
          
          <CardTitle className="text-xl group-hover:text-excel-green transition-colors line-clamp-2">
            {post.title}
          </CardTitle>
        </CardHeader>

        <CardContent>
          <CardDescription className="text-base text-gray-600 mb-4 line-clamp-3">
            {post.excerpt || truncateText(post.content, 150)}
          </CardDescription>

          <div className="flex items-center justify-between text-sm text-gray-500">
            <div className="flex items-center">
              <Calendar className="h-3 w-3 mr-1" />
              {formatDate(post.published_at || post.created_at)}
            </div>
            <div className="flex items-center">
              <Clock className="h-3 w-3 mr-1" />
              {Math.ceil(post.content.length / 1000)} min read
            </div>
          </div>
        </CardContent>
      </Card>
    </Link>
  )
}

export default BlogPost
